var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgSvgGuestRulesGrDogPoopClean = function SvgSvgGuestRulesGrDogPoopClean(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m21.5 21.5.355.178a1 1 0 0 0 1.154-.188l.2-.2a1.111 1.111 0 0 0-.083-1.593l-1.811-1.876a.252.252 0 0 0-.358-.001.251.251 0 0 0-.065.114L20.5 19.5h-4a1 1 0 0 0-1 1v3h2v-1h3l1-1Z",
    fill: "#FFBC44"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5V22A1.5 1.5 0 0 0 9 23.5h1a1.5 1.5 0 0 0 1.5-1.5v-7.5a1 1 0 0 0 2 0l.008-4.86A3.526 3.526 0 0 0 10 6.5h-.739a3.524 3.524 0 0 0-3.507 3.14A1.528 1.528 0 0 1 4.234 11H2a1 1 0 0 0 0 2h2.234a3.5 3.5 0 0 0 1.425-.3",
    fill: "#EEE"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 10.5V22A1.5 1.5 0 0 0 9 23.5h1a1.5 1.5 0 0 0 1.5-1.5v-7.5a1 1 0 0 0 2 0l.008-4.86A3.526 3.526 0 0 0 10 6.5h-.739a3.524 3.524 0 0 0-3.507 3.14A1.528 1.528 0 0 1 4.234 11H2a1 1 0 0 0 0 2h2.234a3.5 3.5 0 0 0 1.425-.3",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.498 4.5a2 2 0 1 0 0-4 2 2 0 0 0 0 4Z",
    fill: "#FFDDA1",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4.5 17.5a2 2 0 0 1-4 0c0-.789 1.019-2.235 1.6-3a.5.5 0 0 1 .8 0c.578.765 1.6 2.211 1.6 3Z",
    fill: "#FFF9BF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 17.407a1.994 1.994 0 0 1-1.682-.925c-.177.313-.285.66-.318 1.018a2 2 0 0 0 4 0 2.552 2.552 0 0 0-.318-1.018 2 2 0 0 1-1.682.925Z",
    fill: "#FFEF5E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M15.5 23.5v-3a1 1 0 0 1 1-1h4l.39-1.563a.251.251 0 0 1 .423-.113l1.809 1.876a1.112 1.112 0 0 1 .083 1.593l-.2.2a1 1 0 0 1-1.154.188L21.5 21.5m-17-4a2 2 0 0 1-4 0c0-.789 1.019-2.235 1.6-3a.5.5 0 0 1 .8 0c.578.765 1.6 2.211 1.6 3Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M11.498 15v-4.5m6 13v-1h3v1h-3Zm-4-9.5 5.5 5.5-5.5-5.5Z",
    stroke: "#191919",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
export default SvgSvgGuestRulesGrDogPoopClean;